const sharedglobals = {
    appUrls: window.appUrls,
    sessionToken: null
  };
  export default sharedglobals;
  